import { _app } from '../base/utils';
import { commonComponents } from '../base';

const components = [
	...commonComponents
]

export default simpleApp = _app(components);
